import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoredHeroDataTypes, StoredMetric } from '../common-tile.model';

@Component({
  selector: 'bhub-tile-metric-picker',
  standalone: false,
  templateUrl: './tile-metric-picker.component.html',
  styleUrl: './tile-metric-picker.component.scss',
})
export class TileMetricPickerComponent {

  @Input() availableMetrics: StoredMetric[];

  // In/Out for selected value
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  //In/Out for selected type
  @Input() type: StoredHeroDataTypes = StoredHeroDataTypes.text;
  @Output() typeChange = new EventEmitter<StoredHeroDataTypes>();

  dataTypeOptions: string[] = Object.values(StoredHeroDataTypes);
  selectedDataType: StoredHeroDataTypes;

  modelValue: any = '';
  displayMetricName: string = '';

  constructor(

  ) {
  }

  onDataTypeChange(newType: string) {
    var enumType = newType as StoredHeroDataTypes;
    this.type = enumType;
    this.typeChange.emit(enumType);

    const resetValue = null;
    this.valueChange.emit(resetValue);
  }

  onValueChange(selection: any) {
    this.valueChange.emit(selection);
  }
}
